import { withChartLayout } from 'components/common';
import { MorseFallScaleStandalone } from 'components/features/chart/special-charts/morse-fall-scale/MorseFallScale';

const MorseFallScalePage = withChartLayout('Morse Fall Scale')(MorseFallScaleStandalone);

export default MorseFallScalePage;
